import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, MapPin, CheckCircle2, Compass } from 'lucide-react';
export function FreeTrialHeroInfo() {
  return <div className="flex flex-col items-start" data-id="element-1520">
      <div className="inline-flex items-center gap-2 bg-storm-red text-white px-4 py-1.5 rounded-full text-sm font-bold uppercase tracking-wide mb-6" data-id="element-1521">
        <Compass className="w-4 h-4" data-id="element-1522" />
        Start Here
      </div>

      <div className="mb-8 inline-flex flex-nowrap items-center gap-3 text-sm md:text-base font-bold text-ink bg-white/90 backdrop-blur-sm py-2 px-4 rounded-full shadow-sm border border-subtle-gray w-fit max-w-full whitespace-nowrap" data-id="element-1523">
        <span className="text-gold tracking-wider shrink-0" data-id="element-1524">★★★★★</span>
        <span className="text-subtle-gray shrink-0" data-id="element-1525">|</span>
        <span className="shrink-0" data-id="element-1526">5.0 Rating From 201 Reviews</span>
      </div>

      <h1 className="text-4xl md:text-5xl lg:text-6xl text-white mb-6 leading-[1.1]" data-id="element-1527">
        Start With a Trial Class at Storm Taekwondo
      </h1>

      <p className="text-xl text-off-white mb-8 max-w-xl leading-relaxed" data-id="element-1528">
        Storm Taekwondo offers beginner-friendly classes and programs for kids,
        adults, and families in Farmington Hills. Tell us what you're interested
        in and we'll help you choose the best starting point.
      </p>

      <ul className="flex flex-wrap gap-x-5 gap-y-2 mb-8" data-id="element-1529">
        {['Kids', 'Adults', 'Families', 'Self-Defense', 'Competition', 'Summer Camp'].map(label => <li key={label} className="flex items-center gap-2 text-off-white text-sm" data-id="element-1530">
            <CheckCircle2 className="w-4 h-4 text-storm-red shrink-0" data-id="element-1531" />
            <span data-id="element-1532">{label}</span>
          </li>)}
      </ul>

      <div className="flex flex-col sm:flex-row gap-3 mb-8 w-full sm:w-auto" data-id="element-1533">
        <a href="#hero-form" className="btn-primary md:hidden text-center" data-id="element-1534">
          Check Availability
        </a>
        <a href="tel:517-220-0621" className="btn-secondary flex items-center justify-center gap-2" data-id="element-1535">
          <Phone className="w-5 h-5" data-id="element-1536" />
          Call 517-220-0621
        </a>
        <Link to="/Programs.html" className="btn-outline border-white text-white hover:bg-white hover:text-ink text-center" data-id="element-1537">
          View Classes & Programs
        </Link>
      </div>

      <div className="flex items-start gap-3 text-off-white/80 text-sm" data-id="element-1538">
        <MapPin className="w-5 h-5 text-storm-red shrink-0 mt-0.5" data-id="element-1539" />
        <p data-id="element-1540">
          24786 Crestview, Farmington Hills, MI 48335 — minutes from Novi,
          Commerce, Walled Lake, Wixom, Livonia, Northville and Waterford.
        </p>
      </div>
    </div>;
}